






























































































































































































































































































































import { Component, Prop, PropSync, Vue, Watch } from 'vue-property-decorator';
import Container from '@/components/Container.vue';
import { adminApi } from '@/api/admin.api';
import { Route } from 'vue-router';
import BaseTable from '@/components/BaseTable.vue';
import SortableTableHeader from '@/components/SortableTableHeader.vue';
import TableActionDropdown from '@/components/TableActionDropdown.vue';
import { Action, State } from 'vuex-class';
import {
  DeleteExceptionsPayload,
  InstanceModuleWithExceptions,
  ResourceTypes,
  RoleRows
} from '@/store/modules/roles-and-permissions/types/roles-and-permissions.types';
import {
  ModuleExceptionTypes,
  ResourceModuleWithExceptions,
  Role
} from '@/store/modules/roles-and-permissions/types/roles-and-permissions.types';
import { Group } from '@/store/modules/admin/types/admin.types';
import { User } from '@/store/modules/subscription/subscription.state';
import {
  EntityTypes,
  ModuleActionTypes
} from '@/store/modules/module-tree/enums/module-tree.enums';
import { RootState } from '@/store/store';
import {
  DeleteGroupsFromRoleQueryParams,
  ResourcesRolesAndExceptionsInstances
} from '@/store/modules/role/types/role.types';
import { ToastProgrammatic as Toast } from 'buefy';
import { ApiState } from '@/store/types/general.types';
import CreateExceptionsModal from '@/views/RolesAndPermissions/components/CreateExceptionsModal.vue';
import AssignToRoleModal from '@/views/RolesAndPermissions/components/AssignToRoleModal.vue';
import ManageExceptionsModal from '@/views/RolesAndPermissions/components/ManageExceptionsModal.vue';
import { handleResolvePermissions } from '@/utils/update-resolve-permission-util';
import { Job } from 'bull';

@Component({
  components: { Container, BaseTable, SortableTableHeader, TableActionDropdown }
})
export default class ViewRolesAndPermissions extends Vue {
  @Prop() groupName!: string;
  @Prop() groupId!: number;
  @Prop() groupTypeName!: string;

  private isRemoveModalActive = false;
  private roleInfoToRemove: { roleId: number | null; roleName: string } = {
    roleId: null,
    roleName: ''
  };

  @Action('role/getResourcesRolesAndExceptionsInstances')
  private getResourcesRolesAndExceptionsInstances!: (payload: {
    resourceId: number;
    resourceType: ResourceTypes;
  }) => Promise<void>;

  @Action('role/deleteGroupsFromRole')
  private deleteGroupsFromRole!: (
    payload: DeleteGroupsFromRoleQueryParams
  ) => Promise<Job[] | void>;

  @Action('rolesAndPermissions/deleteException')
  public deleteException!: (
    payload: DeleteExceptionsPayload
  ) => Promise<Job[] | void>;

  @Action('rolesAndPermissions/getResourceExceptionsByModule')
  public getResourceExceptionsByModule!: (payload: {
    moduleName: string;
    resourceId: string;
  }) => Promise<void>;

  @Action('rolesAndPermissions/getResourceExceptionsByModule')
  public getInstanceResourceExceptionsByModule!: (payload: {
    moduleName: string;
    resourceId: string;
    instanceId: number;
    instanceType: EntityTypes;
  }) => Promise<void>;

  @State(({ role }: RootState) => role.resourcesRolesAndExceptionsInstances)
  private resourceRolesAndExceptionsInstances!:
    | ResourcesRolesAndExceptionsInstances
    | undefined;

  @State(({ role }: RootState) => role.apiState.deleteGroupsFromRole.success)
  private deleteGroupsFromRoleSuccessState!: boolean;

  @State(
    ({ rolesAndPermissions }: RootState) =>
      rolesAndPermissions.apiState.deleteExceptions
  )
  public deleteExceptionState!: ApiState;

  @Action('rolesAndPermissions/finishJobs')
  public finishJobsAction!: (jobState: boolean) => Promise<void>;

  @State(
    ({ rolesAndPermissions }: RootState) => rolesAndPermissions.finishedJobs
  )
  private jobsFinished!: boolean;

  async created() {
    if (!Number.isNaN(this.groupId)) {
      try {
        const { data } = await adminApi.getGroupDetail(this.groupId, true);
        this.groupName = data.name || '';
        this.groupTypeName = data.types[0];
        // fetch roles/exceptions instances for this group
        await this.getResourcesRolesAndExceptionsInstances({
          resourceId: this.groupId,
          resourceType: ResourceTypes.GROUP
        });
      } catch {
        this.groupName = '';
      }
    }
  }

  get roleRows() {
    const roles = this.resourceRolesAndExceptionsInstances?.roles ?? [];
    return roles
      .filter((r) => r.roleName != null)
      .map((r) => ({
        roleId: r.roleId,
        roleName: r.roleName,
        assignedVia: r.assignedVia
      }));
  }

  goToRole(roleId: number) {
    if (!roleId) return;
    this.$router.push(`/admin/roles/${roleId}`);
  }

  get ModuleExceptionTypes() {
    return ModuleExceptionTypes;
  }

  get exceptionRows() {
    const exceptions =
      this.resourceRolesAndExceptionsInstances &&
      this.resourceRolesAndExceptionsInstances.exceptions;
    if (!exceptions) return [];

    const rows: Array<{
      label: string;
      instance: Group | null;
      resources: ResourceModuleWithExceptions[];
    }> = [];

    if (exceptions.resources) {
      exceptions.resources.forEach((resource: ResourceModuleWithExceptions) => {
        rows.push({
          label: resource.label || '-',
          instance: null,
          resources: [resource]
        });
      });
    }

    if (exceptions.instances) {
      exceptions.instances.forEach((inst: InstanceModuleWithExceptions) => {
        const label =
          inst.instanceResources && inst.instanceResources.length > 0
            ? inst.instanceResources[0].label
            : '-';
        rows.push({
          label: label || '-',
          instance: inst.instance || null,
          resources: inst.instanceResources || []
        });
      });
    }
    return rows;
  }

  public getResourceName(
    item: ResourceModuleWithExceptions,
    type: ResourceTypes
  ): string | null {
    switch (type) {
      case ResourceTypes.USER:
        const user: User = item.resource as User;
        return user.userProfile
          ? `${user.userProfile.firstName} ${user.userProfile.lastName}`
          : '';
      case ResourceTypes.GROUP:
        const group = item.resource as Group;
        return group && group.name
          ? group.types
            ? `${group.name}(${group.types.name})`
            : group.name
          : '';
      default:
        return null;
    }
  }

  showTooltip(item: ResourceModuleWithExceptions): boolean {
    // Exclude the current item but match by label
    const otherRows = this.exceptionRows.filter(
      (r) => r.label === item.label && r.resources[0] !== item
    );
    const currentAllow =
      this.getResourceModules(item, ModuleExceptionTypes.ALLOW) || [];

    const currentAllowTags = currentAllow.map((m) => m.tag);
    // Get deny tags for current item
    const currentDeny =
      this.getResourceModules(item, ModuleExceptionTypes.DENY) || [];
    const currentDenyTags = currentDeny.map((m) => m.tag);

    // Track conflicts with other rows
    for (const row of otherRows) {
      const allowModules =
        this.getResourceModules(row.resources[0], ModuleExceptionTypes.ALLOW) ||
        [];
      const allowTags = allowModules.map((m) => m.tag);
      const hasAllPermissionsOther = allowTags.includes('All permissions');

      // Case: other row allows all but current denies anything
      if (hasAllPermissionsOther && currentDenyTags.length > 0) {
        return true;
      }

      const overlapAllowDeny = allowTags.some((tag) =>
        currentDenyTags.includes(tag)
      );

      if (overlapAllowDeny) {
        return true;
      }
    }

    // No conflicts found
    return false;
  }

  public getResourceModules(
    resource: ResourceModuleWithExceptions,
    exceptionType: ModuleExceptionTypes
  ) {
    const module: Array<{
      tag: string;
      tagType: ModuleExceptionTypes;
      module: Role;
    }> = [];

    if (
      resource.exception === exceptionType &&
      resource.action === ModuleActionTypes.ALL
    ) {
      module.push({
        tag: 'All permissions',
        tagType: resource.exception,
        module: resource
      });
    } else {
      const resourceLabel = resource.label
        ? resource.level === 1
          ? resource.label
          : resource.label.split(' ')[0]
        : '';
      if (
        !resource.submodules.length &&
        resource.exception === exceptionType &&
        resourceLabel
      ) {
        module.push({
          tag: resourceLabel,
          tagType: resource.exception,
          module: resource
        });
      } else {
        resource.submodules.forEach((subModule) => {
          const subModuleLabel =
            subModule && subModule.label
              ? subModule.level === 1
                ? subModule.label
                : subModule.label.split(' ')[0]
              : '';

          if (
            subModule &&
            (subModule.exception === exceptionType ||
              subModule.exception === ModuleExceptionTypes.MIXED)
          ) {
            module.push({
              tag: subModuleLabel,
              tagType: subModule.exception,
              module: subModule
            });
          }
        });
      }
    }
    return module;
  }

  refresh() {
    if (this.groupId) {
      this.getResourcesRolesAndExceptionsInstances({
        resourceId: this.groupId,
        resourceType: ResourceTypes.GROUP
      });
      this.roleRows;
      this.exceptionRows;
      this.finishJobsAction(false);
    }
  }

  private openCreateNewExceptionModal(): void {
    this.$buefy.modal.open({
      parent: this,
      component: CreateExceptionsModal,
      hasModalCard: true,
      trapFocus: true,
      fullScreen: true,
      props: {
        modalResourceType: ResourceTypes.GROUP,
        resourceGroup: {
          id: this.groupId!,
          name: this.groupName
        }
      },
      events: {
        close: async (jobs: Job[]) => {
          if (jobs && jobs.length > 0) {
            await handleResolvePermissions.call(this, jobs[0]);
          }
        }
      }
    });
  }

  private assignToRole(): void {
    this.$buefy.modal.open({
      parent: this,
      component: AssignToRoleModal,
      hasModalCard: true,
      trapFocus: true,
      props: {
        role: null,
        resourceType: ResourceTypes.GROUP,
        selectedGroup: {
          id: this.groupId!,
          name: this.groupName,
          types: {
            name: this.groupTypeName
          }
        }
      },
      events: {
        roleUpdated: async (jobs: Job[]) => {
          if (jobs) {
            await handleResolvePermissions.call(this, jobs[0]);
          }
        }
      }
    });
  }

  private handleRemoveRole(role: RoleRows): void {
    this.roleInfoToRemove = role;
    this.isRemoveModalActive = true;
  }

  private async confirmRemoveGroupFromRole(): Promise<void> {
    if (this.groupId && this.roleInfoToRemove.roleId) {
      const jobs = await this.deleteGroupsFromRole({
        id: this.roleInfoToRemove.roleId,
        groupIds: [this.groupId]
      });
      if (jobs) {
        await handleResolvePermissions.call(this, jobs[0]);
      }
    }
  }

  public handleManageExceptions(
    resource: ResourceModuleWithExceptions,
    instance: ResourceModuleWithExceptions
  ): void {
    if (instance) {
      this.getInstanceResourceExceptionsByModule({
        moduleName: resource.moduleName,
        resourceId: `${EntityTypes.GROUP}_${resource.resource.id}`,
        instanceId: instance.id,
        instanceType: EntityTypes.GROUP
      });
    } else {
      this.getResourceExceptionsByModule({
        moduleName: resource.moduleName,
        resourceId: `${EntityTypes.GROUP}_${resource.resource.id}`
      });
    }
    this.$buefy.modal.open({
      parent: this,
      component: ManageExceptionsModal,
      hasModalCard: true,
      trapFocus: true,
      fullScreen: true,
      props: {
        module: resource,
        resourceId: resource,
        instanceId: instance ? { instance: instance } : undefined
      },
      events: {
        close: async (jobs: Job[]) => {
          if (jobs) {
            await handleResolvePermissions.call(this, jobs[0]);
          }
        }
      }
    });
  }

  public handleDeleteExceptions(
    resource: ResourceModuleWithExceptions,
    instance: ResourceModuleWithExceptions
  ): void {
    let moduleName = resource.moduleName;
    if (instance) {
      const instanceId = `${EntityTypes.GROUP}_${instance.id}`;
      const rootModules: string[] = resource.moduleName.split('-').slice(0, 2);
      moduleName = resource.moduleName.replace(
        rootModules.join('-'),
        instanceId
      );
    }
    this.$buefy.dialog.confirm({
      message: `<p class="buefy-dialog-title">Delete exceptions</p><p class="buefy-dialog-content  mb-4">Are you sure you want to delete exceptions?</p>`,
      confirmText: 'Delete exceptions',
      onConfirm: async () => {
        const jobs = await this.deleteException({
          resourceId: `${EntityTypes.GROUP}_${this.groupId}`,
          module: moduleName
        });
        if (jobs) {
          await handleResolvePermissions.call(this, jobs[0]);
        }
      },
      canCancel: ['button'],
      cancelText: 'Cancel',
      onCancel: undefined
    });
  }

  @Watch('deleteGroupsFromRoleSuccessState')
  private async watchDeleteGroupsFromRoleSuccessState() {
    if (this.deleteGroupsFromRoleSuccessState) {
      Toast.open({
        message: 'Group removed from role',
        type: 'is-success',
        position: 'is-top'
      });
      this.isRemoveModalActive = false;
    }
  }

  @Watch('deleteExceptionState')
  public async onDeleteExceptionState(state: ApiState): Promise<void> {
    if (state.success) {
      Toast.open({
        queue: true,
        position: 'is-top',
        message: `Exceptions deleted`,
        type: 'is-dark',
        duration: 5000
      });
    } else if (state.error) {
      Toast.open({
        queue: true,
        position: 'is-top',
        message: 'Something went wrong. Try again.',
        type: 'is-danger',
        duration: 5000
      });
      this.refresh();
    }
  }

  @Watch('jobsFinished')
  private async watchfinishedJobs() {
    if (this.jobsFinished) {
      this.refresh();
    }
  }
}
